import { Module } from 'vuex';

import { RootState } from 'frontend/types';
import { LearningPathV2 } from 'frontend/types/learningPathV2';

const learningPathV2: Module<LearningPathV2, RootState> = {
  namespaced: true,
  state: undefined,
  getters: {
    learningPath: state => state,
  },
  mutations: {
    setValue(state: LearningPathV2, value: LearningPathV2): void {
      Object.assign(state, value);
    },
  },
};

export default learningPathV2;
